import { render } from "./HideComment.vue?vue&type=template&id=56541543"
import script from "./HideComment.vue?vue&type=script&lang=js"
export * from "./HideComment.vue?vue&type=script&lang=js"

import "./HideComment.vue?vue&type=style&index=0&id=56541543&lang=css"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__